import { useTranslation } from 'react-i18next';
import { SkillLevelCategory } from '@sportschool/shared-types';
import { cn } from '@/lib/utils';

const CATEGORY_STYLES: Partial<Record<SkillLevelCategory, string>> = {
  [SkillLevelCategory.Children]: 'bg-blue-500/10 text-info border-blue-500/20',
  [SkillLevelCategory.Youth]: 'bg-violet-500/10 text-violet-600 border-violet-500/20 dark:text-violet-300',
};

/**
 * Compact tag marking a children's or youth skill level (levels in different categories may share a name).
 * Renders nothing for adult levels.
 */
export function SkillLevelCategoryTag({ category, className }: { category?: SkillLevelCategory | null; className?: string }) {
  const { t } = useTranslation();
  if (!category || category === SkillLevelCategory.Adults) return null;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded border px-1 py-px text-[9px] font-bold uppercase leading-none whitespace-nowrap',
        CATEGORY_STYLES[category],
        className
      )}
    >
      {t(`settings.skillLevels.categoryBadge.${category}`)}
    </span>
  );
}
